@for (line of formattedLines; track line) {
  {{line}}<br>
}
{{ address.countryCode | countryName:'combined' }}
